function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "29",
  height: "30",
  viewBox: "0 0 29 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M23.229.07a5.772 5.772 0 100 11.545 5.772 5.772 0 000-11.545zm2.208 6.46h-1.52v1.518a.688.688 0 01-1.377 0V6.531h-1.517a.688.688 0 010-1.376h1.517v-1.52a.688.688 0 111.377 0v1.52h1.52a.688.688 0 110 1.376z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.342 11.55a12.02 12.02 0 00-4.756-4.48 5.778 5.778 0 004.756 4.48zm.85 1.717a7.422 7.422 0 01-7.37-6.944A12.023 12.023 0 003.523 26.239a12.03 12.03 0 0017.01-.001 12.024 12.024 0 002.659-12.97zm-7.659-.098a1.513 1.513 0 00-1.65 2.47 1.514 1.514 0 101.65-2.47zm-5.361.33a1.514 1.514 0 00-1.067-.446h-.018a1.514 1.514 0 00.018 3.03 1.514 1.514 0 001.067-2.584zm-.445 9.792a6.015 6.015 0 008.317-5.559H6.014a6.009 6.009 0 003.713 5.559z",
  fill: "#fff"
})));